<ng-content select="fieldControl"></ng-content>
<div class="flex w-full items-start gap-10">
  <ng-content select="fieldErrors"></ng-content>
  @if (isCountVisible || isGreaterThanMaxLength) {
    <span
      [class.text-gray-750]="!isGreaterThanMaxLength"
      [class.text-crimson-600]="isGreaterThanMaxLength"
      class="ml-auto mr-2 mt-[6px] text-xs"
      >{{ symbolsCount }}/{{ maxLimit }}</span
    >
  }
</div>
